﻿import "./InlineSpinner.scss";

import { SbbLoadingIndicatorCircle } from "@sbb-esta/lyne-react/loading-indicator-circle";
import { getResourceStrict, ResourceKey } from "providers";
import React from "react";

interface InlineSpinnerProps {
  resourceKey?: ResourceKey;
  text?: string;
}

export const InlineSpinner: React.FC<InlineSpinnerProps> = ({ resourceKey, text }) => {
  if (!text && resourceKey) {
    text = getResourceStrict(resourceKey);
  }

  return (
    <div className="d-flex">
      <div className="me-1">
        <SbbLoadingIndicatorCircle />
      </div>

      {text && <div className="label d-inline-block ms-1">{text}</div>}
    </div>
  );
};
